module.exports = __webpack_public_path__ + "static/media/products_vertical_dark.8a89ab5d.jpg";